export const MARKETPLACE_DATA_PICKER_MODAL_ID = 'marketplace-data-picker-modal'

export const closeMarketplaceDataPickerModal = () => {
    const checkbox = document.getElementById(MARKETPLACE_DATA_PICKER_MODAL_ID) as HTMLInputElement | null
    if (checkbox) {
        checkbox.checked = false
    }
}
